import { useQuery } from '@tanstack/react-query';

// Services
import { getManagerPages } from './pagesService';

/**
 * Get manager pages configuration for dynamic routing
 * @param {QueriesOptions} [options = {}] - The query options
 * @returns {import('@tanstack/react-query').UseQueryResult<ApiPages, Error>} The pages configuration
 */
export const useManagerPages = (options = {}) => useQuery({
  queryKey: ['managerPages'],
  queryFn: () => getManagerPages(),
  staleTime: 5 * 60 * 1000, // 5 minutes - pages config doesn't change often
  retry: false,
  ...options,
});
